import { createFileRoute } from '@tanstack/react-router'
import { BroadcastModeRedirect } from '@/features/chat'

export const Route = createFileRoute('/chat/broadcasts/new')({
  component: () => <BroadcastModeRedirect mode="compose" />,
  staticData: { authorize: true },
})
